import { useSearchParams } from 'react-router-dom'

enum URLFeatureFlag {
	// A feature to show a chat bot powered by AI.
	// Started during the hackathon of 2025-10-09
	AIChatBot = 'ai-chat-bot',
	// A feature to show login with CO2 AI feature.
	// Should be removed when ready SSO with CDP is ready & working.
	// Around 2024-04-01
	SSOWithCO2AI = 'sso-with-co2-ai',
	SSOWithCDP = 'sso-with-cdp',
	// A feature to show template selector in request creation
	// Should be removed when ready
	// Around 2025-05-01
	FormTemplate = 'form-template',
}

const defaultValues: Partial<Record<URLFeatureFlag, boolean>> = {} as const

// Hook to check if an URL feature flag is enabled or not.
const useUrlFeatureFlag = (flag: URLFeatureFlag): boolean => {
	const [searchParams] = useSearchParams()
	const urlFeatureFlag = !!(searchParams.get(flag) ?? defaultValues[flag])
	if (urlFeatureFlag) {
		return true
	}
	// You can also set it more permanently in the local storage for testing.
	// Just open the console and run:
	// localStorage.setItem('co2ai-feature-flag-ai-chat-bot', '1')
	// to enable the AI chat bot feature flag.
	// Or
	// localStorage.removeItem('co2ai-feature-flag-ai-chat-bot')
	// to disable it again.
	return !!localStorage.getItem(`co2ai-feature-flag-${flag}`)
}

export { URLFeatureFlag, useUrlFeatureFlag }
